import React from "react";

/**
 * BridgeDatum logo treatment.
 * PNG carries a white background; rendered on opaque white surfaces it blends naturally.
 * On dark canvas we render a clean executive wordmark in white + orange.
 */
const PNG_URL =
  "https://customer-assets.emergentagent.com/job_fa6b9c62-97b5-4fc7-81e3-8040206e9553/artifacts/z4xpy28i_BRIDGEDATUM.png";

const BridgeDatumLogo = ({ variant = "navbar", className = "" }) => {
  if (variant === "white" || variant === "stack") {
    const stacked = variant === "stack";
    return (
      <div className={`${stacked ? "flex flex-col items-center text-center" : "inline-flex items-center"} ${className}`}>
        <div className={`font-bd font-bold tracking-tight leading-none ${stacked ? "text-5xl sm:text-6xl" : "text-3xl sm:text-4xl"}`}>
          <span className="text-white">Bridge</span>
          <span className="text-[#F58220]">Datum</span>
        </div>
        {stacked && (
          <div className="mt-4 text-[11px] tracking-[0.32em] uppercase font-semibold text-[#D4AF37]">
            AI · Data · Governance · Sustainability
          </div>
        )}
      </div>
    );
  }

  const heights = {
    navbar: "h-20 sm:h-24",
    hero: "h-28 sm:h-32",
  };

  return (
    <img
      src={PNG_URL}
      alt="BridgeDatum"
      className={`${heights[variant] || heights.navbar} w-auto object-contain select-none ${className}`}
      draggable="false"
    />
  );
};

export default BridgeDatumLogo;
